<template>
  <div 
    v-if="slideElements.length" 
    class="step regimen-step">
    <h3>Looks like your regimen might need ...</h3>
    <carousel
      ref="my-carousel"
      :navigation-enabled="true"
      :loop="true"
      :per-page="slidePerPage"
      :scroll-per-page="true"
      navigation-next-label=">"
      navigation-prev-label="<"
      @pageChange="handleChangeCarousel">
      <slide
        v-for="element in slideElements"
        :key="element.id">

        <div class="slide-item">
          <RegimenElement
            :abr="element.abr"
            :name="element.element_name"
            :description="element.element_type"/>
        </div>
      </slide>
    </carousel>
  </div>
  <div 
    v-else 
    class="step regimen-step">
    <h2>Your Regimen has all elements <a 
      href="#" 
      @click="lastSwipe">next</a></h2>
  </div>
</template>
<script>
import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import profileMixin from "@/mixins/profileMixin";

Vue.use(VueCarousel);

import {Carousel, Slide} from 'vue-carousel';
import {mapActions, mapGetters} from "vuex";
import {constants} from "@/constants";
import RegimenElement from "../../../RegimenElement";

export default {

    components: {
        RegimenElement,
        Carousel,
        Slide
    },
    mixins: [profileMixin],

    data: () => ({
        formData: {},
        slideElements: [],
        curlTypes: constants.curlTypes,
        currentSlide: 1,
        slidePerPage: 3
    }),

    computed: {
        ...mapGetters(['user', 'profile', 'regimenElements']),
    },

    created() {
        this.fetchProfileData();
    },

    destroyed() {
        this.fetchUserRegimenElements(this.formData);
    },

    methods: {
        ...mapActions(['fetchProfile', 'fetchRegimenElements', 'fetchUserRegimenElements']),

        fetchProfileData() {
            this.formData['userId'] = this.user.id;
            this.formData['quizId'] = constants.quizUrls.CURL_PROFILE_ID;

            this.fetchProfile(this.formData).then(() => {
                this.formData['methodId'] = this.getMethodIdByHairType();
                this.formData['check'] = 'true';
                this.fetchRegimenElementsData(this.formData);
            })
        },

        fetchRegimenElementsData(formData) {
            this.fetchRegimenElements(formData).then(() => {
                this.slideElements = this.regimenElements;
                console.log(this.slideElements)
            });
        },

        handleChangeCarousel(val) {
            this.currentSlide = (val === 1) ? 1 : this.currentSlide + 1;
            return (val === 0 && this.currentSlide === this.getSlidePages()) ? this.lastSwipe() : '';
        },

        lastSwipe() {
            this.$emit('nextStep');
        },

        getSlidePages() {
            return Math.ceil(this.regimenElements.length/this.slidePerPage);
        },

        getMethodIdByHairType() {
            return(this.curlTypes[this.profile.curl_sit_spectrum])
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/modals/RegimenChecker/steps/RegimenStep.vue